import React from 'react';

import { withUAPLThemedStyles } from '../with-themed-styles';
import { AdPlacementMmaBase } from './mma-ad-placement-base';
import { AdPlacementMmaBaseV2 } from './mma-ad-placements-v2/mma-ad-placement-base-v2';
import { CircleRightArrow } from '../shared-components';

import {
  getMmaInMsanV2MSANRectangle120x100Styles,
  getMmaInMsanV2RefreshedMSANRiver191x100Styles,
  getMmaInMsanV2RefreshedMSNRestoday124x100Styles,
  getMmaInMsanV2RefreshedMSNCarousel169x100Styles,
  getMmaInMsanV2RefreshedMicrosoftEdgeCarousel201x100Styles,
  getMmaInMsanV2RefreshedMSNPartnerStripe153x100Styles,
  getMmaInMsanV2RefreshedMSANBanner2x1Styles,
  getMmaInMsanV2RefreshedMicrosoftEdgeMobile1x1Styles,
  getMmaInMsanV2RefreshedMSANRectangle191x100Styles,
} from '../styles';

export const AdPlacementMmaInMsanV2MicrosoftEdgeCarousel201x100 = withUAPLThemedStyles(

  (props: React.ComponentProps<typeof AdPlacementMmaBaseV2>) => (<AdPlacementMmaBaseV2
    {...props}
    showShortHeadline
    isMultiLineShortHeadline={false}
    showLongHeadline={false}
    showFinalUrl={false}
    showDescription
    showCallToAction={false}
    showBusinessNameWithLogoTop
    showAdChoiceIconArea
    showAdIcon
    showChoiceIcon
    showBrightStyleChoiceIcon
    description={undefined}
    callToAction={undefined}
    showGradient
    showLogo
  />),
  getMmaInMsanV2RefreshedMicrosoftEdgeCarousel201x100Styles,
  { componentName: 'AdPlacementMmaInMsanV2MicrosoftEdgeCarousel201x100' }
);

export const AdPlacementMmaInMsanV2MSANBanner2x1 = withUAPLThemedStyles(

  (props: React.ComponentProps<typeof AdPlacementMmaBaseV2>) => (<AdPlacementMmaBaseV2
    {...props}
    showShortHeadline
    showLongHeadline={false}
    showFinalUrl={false}
    showDescription
    showCallToAction={false}
    showAdChoiceIconArea
    isMultiLineShortHeadline={false}
    description={undefined}
    callToAction={undefined}
    showBusinessNameInAdChoiceArea
    showAdIcon
    showChoiceIcon={false}
  />),
  getMmaInMsanV2RefreshedMSANBanner2x1Styles,
  { componentName: 'AdPlacementMmaInMsanV2MSANBanner2x1' }
);

export const AdPlacementMmaInMsanV2MSANRiver191x100 = withUAPLThemedStyles(

  (props2: React.ComponentProps<typeof AdPlacementMmaBaseV2>) => (<AdPlacementMmaBaseV2
    {...props2}
    showShortHeadline
    showLongHeadline={false}
    showDescription
    showCallToAction={false}
    isMultiLineDescription={false}
    showBusinessNameWithLogoTop
    showAdChoiceIconArea
    showBusinessNameInAdChoiceArea={false}
    showAdIcon
    showChoiceIcon
    showLogo
  />),
  getMmaInMsanV2RefreshedMSANRiver191x100Styles,
  { componentName: 'AdPlacementMmaInMsanV2MSANRiver191x100' }
);

export const AdPlacementMmaInMsanV2MSNCarousel169x100 = withUAPLThemedStyles(

  (props: React.ComponentProps<typeof AdPlacementMmaBaseV2>) => (<AdPlacementMmaBaseV2
    {...props}
    showShortHeadline={false}
    showLongHeadline
    showDescription={false}
    showCallToAction={false}
    showBusinessNameWithLogoTop={false}
    showAdChoiceIconArea
    isMultiLineLongHeadline={false}
    description={undefined}
    callToAction={undefined}
    showBusinessNameInAdChoiceArea
    showAdIcon
    showBrightStyleChoiceIcon
    showChoiceIcon
  />),
  getMmaInMsanV2RefreshedMSNCarousel169x100Styles,
  { componentName: 'AdPlacementMmaInMsanV2MSNCarousel169x100' }
);

export const AdPlacementMmaInMsanV2MSNPartnerStripe153x100 = withUAPLThemedStyles(

  (props: React.ComponentProps<typeof AdPlacementMmaBaseV2>) => (<AdPlacementMmaBaseV2
    {...props}
    showShortHeadline={false}
    showLongHeadline
    showFinalUrl={false}
    showDescription={false}
    showCallToAction={false}
    showAdChoiceIconArea
    showBusinessNameInAdChoiceArea
    showGradient={false}
    isMultiLineLongHeadline={false}
    callToAction={undefined}
    showAdIcon={false}
    showChoiceIcon={false}
  />),
  getMmaInMsanV2RefreshedMSNPartnerStripe153x100Styles,
  { componentName: 'AdPlacementMmaInMsanV2MSNPartnerStripe153x100' }
);

export const AdPlacementMmaInMsanV2MSNRestoday124x100 = withUAPLThemedStyles(

  (props: React.ComponentProps<typeof AdPlacementMmaBaseV2>) => (<AdPlacementMmaBaseV2
    {...props}
    showShortHeadline
    showLongHeadline={false}
    showFinalUrl={false}
    showDescription={false}
    showCallToAction={false}
    isMultiLineShortHeadline={false}
    description={undefined}
    callToAction={undefined}
    showBusinessName
    showBusinessNameWithLogoTop
    showLogo={false}
    showAdChoiceIconArea
    showBusinessNameInAdChoiceArea={false}
    showAdIcon
    showChoiceIcon
  />),
  getMmaInMsanV2RefreshedMSNRestoday124x100Styles,
  { componentName: 'AdPlacementMmaInMsanV2MSNRestoday124x100' }
);

export const AdPlacementMmaInMsanV2MSANRectangle191x100 = withUAPLThemedStyles(

  (props: React.ComponentProps<typeof AdPlacementMmaBaseV2>) => (<AdPlacementMmaBaseV2
    {...props}
    showShortHeadline
    showLongHeadline={false}
    showFinalUrl={false}
    showDescription={false}
    showCallToAction={false}
    isMultiLineShortHeadline={false}
    callToAction={undefined}
    showBusinessNameWithLogoTop
    customizedComponent={CircleRightArrow}
    showLogo
    showAdChoiceIconArea
    showChoiceIcon
    showAdIcon={false}
  />),
  getMmaInMsanV2RefreshedMSANRectangle191x100Styles,
  { componentName: 'AdPlacementMmaInMsanV2MSANRectangle191x100' }
);

// to be deprecated
export const AdPlacementMmaInMsanV2MSANRectangle120x100 = withUAPLThemedStyles(

  (props: React.ComponentProps<typeof AdPlacementMmaBase>) => (<AdPlacementMmaBase
    {...props}
    showShortHeadline
    showLongHeadline={false}
    showFinalUrl={false}
    showDescription={false}
    showCallToAction={false}
    showAdLabel={false}
    showGradient
    isMultiLineShortHeadline
    description={undefined}
    callToAction={undefined}
    showBusinessName
    showBusinessNameAdLabel
  />),
  getMmaInMsanV2MSANRectangle120x100Styles,
  { componentName: 'AdPlacementMmaInMsanV2MSANRectangle120x100' }
);

export const AdPlacementMmaInMsanV2MicrosoftEdgeMobile1x1 = withUAPLThemedStyles(

  (props: React.ComponentProps<typeof AdPlacementMmaBaseV2>) => (<AdPlacementMmaBaseV2
    {...props}
    showShortHeadline
    showLongHeadline={false}
    showFinalUrl={false}
    showDescription={false}
    showCallToAction={false}
    isMultiLineShortHeadline={false}
    description={undefined}
    callToAction={undefined}
    showAdChoiceIconArea
    showBusinessNameWithLogoTop
    showAdIcon
    showChoiceIcon
    showLogo
  />),
  getMmaInMsanV2RefreshedMicrosoftEdgeMobile1x1Styles,
  { componentName: 'AdPlacementMmaInMsanV2MicrosoftEdgeMobile1x1' }
);
